import { BadgeV3 } from '@cimplico/components';
import { CheckIcon, ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { WorksheetReviewCondition } from '../../../../types/worksheet';

type ReviewConditionProps = {
    condition: WorksheetReviewCondition;
};

function ReviewCondition({ condition }: ReviewConditionProps): JSX.Element {
    return (
        <div className="h-fit flex flex-col gap-2 bg-white relative">
            <div className="flex items-start gap-2">
                {condition.satisfied ? (
                    <BadgeV3 color="green" leftIcon={<CheckIcon />} />
                ) : (
                    <BadgeV3 color="yellow" leftIcon={<ExclamationTriangleIcon />} />
                )}
                <p className="text-sm my-auto leading-none font-medium text-gray-700">{condition.description}</p>
            </div>
        </div>
    );
}

export default ReviewCondition;
